import React from 'react';
import Cards from '../cards/Cards';

const Projects = () => {
    return (
        <div className="main-body">
            <h3>Projects</h3>
            <hr></hr>
            <h4>Check out what I've worked on.</h4>
            <Cards/>
        </div>
    )
}

export default Projects;